/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssociateClientTeamsRequest
 */
export interface AssociateClientTeamsRequest {
    /**
     * 
     * @type {Set<string>}
     * @memberof AssociateClientTeamsRequest
     */
    clientTeams: Set<string>;
}

/**
 * Check if a given object implements the AssociateClientTeamsRequest interface.
 */
export function instanceOfAssociateClientTeamsRequest(value: object): value is AssociateClientTeamsRequest {
    if (!('clientTeams' in value) || value['clientTeams'] === undefined) return false;
    return true;
}

export function AssociateClientTeamsRequestFromJSON(json: any): AssociateClientTeamsRequest {
    return AssociateClientTeamsRequestFromJSONTyped(json, false);
}

export function AssociateClientTeamsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssociateClientTeamsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientTeams': json['clientTeams'],
    };
}

export function AssociateClientTeamsRequestToJSON(value?: AssociateClientTeamsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientTeams': Array.from(value['clientTeams'] as Set<any>),
    };
}

